import { Stack } from "@atlaskit/primitives-next";

import { useLoggedInUser } from "@/utils/logged-in-user-provider";

import { CustomerNameAndLogoHeader } from "../../../common/customer-name-and-logo-header";
import { LegalBanner } from "../../../common/legal-footer/src/legal-banner";
import { RelationshipSection } from "../../../common/relationships";
import { getCurrentTime } from "../../../common/utils";
import { CustomerWelcomeBanner } from "../../../common/welcome-banner";
import { useFastshiftSelector } from "../../../state";

import { useDashboardV2PageAnalytics } from "./hooks";
import { MigrationStatusTable } from "./migration-status-table";
import { SummarySection } from "./summary-section";

export const FastshiftDashboardV2 = () => {
    const { data: userDetails } = useFastshiftSelector(
        (state) => state.userDetails
    );

    const userInfo = useLoggedInUser();
    const currentTime = getCurrentTime();

    useDashboardV2PageAnalytics();

    return (
        <Stack space="space.400">
            {userDetails?.userType === "CUSTOMER" && (
                <Stack space="space.300">
                    <CustomerWelcomeBanner
                        currentTime={currentTime}
                        userName={userInfo?.name}
                    />
                    <LegalBanner />
                </Stack>
            )}
            {userDetails?.userType !== "CUSTOMER" && (
                <CustomerNameAndLogoHeader />
            )}
            <SummarySection />
            <RelationshipSection />
            <MigrationStatusTable />
        </Stack>
    );
};
